export const shouldLoad = () => document.querySelector('.klt-card') !== undefined;
